<template>
    <div class="Pathbox">
        <div class="CurrPath">
            <span class="CurrHome"><i></i> 当前位置：</span>
            <span @click="toLink('/')">首页</span>
            <span class="linecicrl">·</span><span>{{CurrPathName}}</span>
        </div>
        <div class="CurrChild">
            <template v-if="CurrPath=='/About' && navList.length">
                <span :class="CurrAct==(i+1)?'act':''" @click="NavChooise(i+1,v.ID,v.Type)" v-for="(v,i) in navList" :key="i">{{v['Name']}}</span>
            </template>
            <template v-if="CurrPath=='/Recruit' && navList.length">
                <span :class="CurrAct==(i+1)?'act':''" @click="NavChooise(i+1,v.ID,v.Type)" v-for="(v,i) in navList" :key="i">{{v['Name']}}</span>
            </template>
            <template v-if="CurrPath=='/ListArt' && navList.length">
                <span :class="CurrAct==(i+1)?'act':''" @click="NavChooise(i+1,v.ID,v.Type)" v-for="(v,i) in navList" :key="i">{{v['Name']}}</span>
            </template>
            <template v-if="CurrPath=='/Product' && navList.length">
                <span :class="CurrAct==(i+1)?'act':''" @click="NavChooise(i+1,v.ID,v.Type)" v-for="(v,i) in navList" :key="i">{{v['Name']}}</span>
            </template>
        </div>
    </div>
</template>
<script>
import {GetFNavColumnsByCid} from '@/requestPub/api';
export default {
    data(){
        return{
            CurrAct:'',
            navList:'',
        }
    },
    computed:{
        CurrPath(){
            return this.$route.path;
        },
        CurrPathName(){
            var n = this.$route.path;
            let names= '';
            switch (n) {
                case '/Remark':
                    names = '用户反馈';
                    break;
                case '/About':
                    names = '关于我们';
                    break;
                case '/Recruit':
                    names = '公司招聘';
                    break;
                case '/ListArt':
                    names = '新闻资讯'; 
                    break;
                case '/Product':
                    names = '产品介绍'; 
                    break;
                case '/Trainingsite':
                    names = '培训现场'; 
                    break;
                case '/SearchRet':
                    names = '搜索结果'; 
                    break;
            }
            return names;
        }
    },
    watch:{
        CurrAct(n,o){   
            let p = (this.$route.path).substring(1); 
            if(n){
               switch (p) {
                    case 'Product':
                        this.$emit('ProEmit',n)
                       break;
                    case 'ListArt':
                        this.$emit('ListArtEmit',n)
                       break;
                }
            }
        }
    },
    mounted(){
        this.CurrAct = this.$route.query.act || 1;
        this.isSearchRet = this.$route.query.isSearchRet;
        if(!this.$route.query.isSearchRet){
            GetFNavColumnsByCid({Cid:this.$route.query.id}).then((e)=>{
                this.navList = e.Data.nav;
                this.$emit('CurrIds',{types:e.Data.nav.length>0?e.Data.nav[0].Type:e.Data.p['types'],ids:e.Data.nav.length>0?e.Data.nav[0].ID : e.Data.p['ID'],CurrAct: this.CurrAct});
            })
        }
    },
    methods:{
        NavChooise(n,ids,types){
            this.CurrAct=n;
            this.$emit('CurrIds',{ids:ids,CurrAct:n,types:types})
        },
        toLink(p){
            this.$router.push(p);
        }
    }
}
</script>
<style lang="scss">
.Pathbox{
    // background: pink;
    display: inline-flex;
    background: url('../../assets/nav_bg.png') no-repeat left center;
    background-size: 20% 100%;
    width:1260px;
    padding: 0 calc(calc(100% - 1260px)  / 2);
    height: 30px;
    .CurrPath{
        text-align: left;
        width: 25%;
        color:#fff;
        line-height: 30px;
        background: url('../../assets/nav_bg.png') no-repeat left center;
        background-size: 100% 100%;
        span{
            font-size: 14px;
            margin: 0 3px;
        }
        span:not(.CurrHome){
             font-size: 15px;
            &:hover{
                cursor: pointer;
            }
        }
        .linecicrl{
            font-weight: bold;
        }
        span:nth-child(1){
            padding-left: 25px;
            background: url('../../assets/addr.png') no-repeat left center;
            background-size: 18px;
        }
    }
    .CurrChild{
        flex: 1;
        text-align: left;
        span{
            display: inline-block;
            font-size: 14px;
            height: 28px;
            margin: 0 20px 0 15px;
            line-height: 30px;
            color:rgba(51, 51, 51, 1);
            font-weight: 400;
            border-bottom: 2px solid transparent;
            &:hover{
                cursor: pointer;
                border-bottom: 2px solid rgba(65, 96, 206, 0.6) ;
            }
        }
        .act{
           border-bottom: 2px solid rgba(65, 96, 206, 0.6) 
        }
    }
}
</style>